import React, { useContext } from 'react';

import { DeviceInfoContext } from '../../../../device';
import { AnomalySectionProps } from './index';
import { DataUsageAppsSection } from './dataUsageAppsSection';
import { DataUsageHourlySection } from './dataUsageHourlySection';

export function DataUsageSection(props: AnomalySectionProps) {
  const { platformType } = useContext(DeviceInfoContext);

  if (platformType === 'android') {
    return <DataUsageAppsSection {...props} />;
  }

  return <DataUsageHourlySection {...props} />;
}
